import { useEffect, useState } from 'react';
import type { FeedSnapshot } from '../../lib/rt/feed';

/** Where the feed is, said in the panel's bar: live, catching up, or off. */
export function FeedBadge({ feed }: { feed: FeedSnapshot }) {
  // A clock of its own, so "how long ago" moves on between samples.
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 5000);
    return () => window.clearInterval(timer);
  }, []);
  const ageSeconds = feed.latest ? Math.max(0, Math.round((now - Date.parse(feed.latest.t)) / 1000)) : null;
  const label =
    feed.status === 'live' ? 'LIVE' : feed.status === 'reconnecting' ? 'RECONNECTING' : feed.status === 'connecting' ? 'CONNECTING' : 'OFFLINE';
  return (
    <div className="rtbar">
      <span className={`rtbadge rtbadge--${feed.status}`}>{label}</span>
      {feed.info?.simulated && (
        <span className="rtbadge rtbadge--sim" title="Readings come from the drilling simulator, not from a rig">
          SIMULATED
        </span>
      )}
      {feed.latest && (
        <span className="rtbar-meta">
          Last data {new Date(feed.latest.t).toLocaleTimeString(undefined, { hour12: false })}
          {ageSeconds !== null && ageSeconds > 15 && ` (${ageSeconds}s ago)`}
        </span>
      )}
    </div>
  );
}

/** What a real-time screen shows instead of a log when there is none. */
export function FeedMissing({ feed }: { feed: FeedSnapshot }) {
  if (feed.status === 'error') {
    return (
      <div className="alert alert--page" role="alert">
        {feed.error}
      </div>
    );
  }
  return (
    <div className="placeholder rtnone">
      <h2>No real-time feed for this well</h2>
      <p>
        Live readings appear here once the well is connected to a rig feed. For a demonstration, the API can
        simulate one: set <code>RT_SIM_WELL_ID</code> to this well's id in <code>wxp-api/.env</code> and restart it.
      </p>
    </div>
  );
}
